export default function ResponsiveListTable({
  columns = [],
  data = [],
  loading = false,
  emptyMessage = 'Nenhum registro encontrado.',
  rowKey,
}) {
  const getRowKey = (row, idx) => {
    if (typeof rowKey === 'function') return rowKey(row, idx);
    if (typeof rowKey === 'string' && row[rowKey] != null) return row[rowKey];
    return (
      row.id ??
      row.uuid ??
      row.unidade_id ??
      row.modelo_id ??
      row.execucao_id ??
      idx
    );
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        <div className="animate-pulse space-y-3">
          <div className="h-4 bg-gray-200 rounded w-1/4" />
          <div className="h-10 bg-gray-200 rounded" />
          <div className="h-10 bg-gray-200 rounded" />
          <div className="h-10 bg-gray-200 rounded" />
        </div>
      </div>
    );
  }

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        <p className="text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100">
      {/* Versão Desktop */}
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              {columns.map((c) => (
                <th
                  key={c.key}
                  className={`px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider ${c.className || ''}`}
                >
                  {c.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.map((row, idx) => (
              <tr key={getRowKey(row, idx)} className="hover:bg-gray-50">
                {columns.map((c) => (
                  <td key={c.key} className={`px-6 py-4 ${c.className || ''}`}>
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Versão Mobile */}
      <div className="block md:hidden divide-y divide-gray-200">
        {data.map((row, idx) => (
          <div key={getRowKey(row, idx)} className="p-4">
            {columns.map((c) => (
              <div key={c.key} className="mb-2">
                <span className="block text-xs font-semibold text-gray-500">{c.header}</span>
                <span className="block text-gray-900">
                  {c.render ? c.render(row) : row[c.key]}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}